import React, { useState } from 'react';
import { withTranslation } from 'react-i18next';
import { Dropdown, DropdownToggle, DropdownMenu, Row, Col, Spinner } from 'reactstrap';
import PropTypes from 'prop-types';
const BookingNotificationDropdown = props => {
	const [menu, setMenu] = useState(false);
	const [notificationData, setNotificationData] = useState([]);
	const [unreadCount, setUnreadCount] = useState(0);
	const [isLoading, setIsLoading] = useState(false);

	return (
		<React.Fragment>
			<Dropdown isOpen={menu} toggle={() => setMenu(!menu)} className="dropdown d-inline-block" tag="li">
				<DropdownToggle
					className="btn header-item noti-icon position-relative"
					tag="button"
					id="page-header-booking-notifications-dropdown"
				>
					<i className={unreadCount > 0 ? 'bx bx-chat bx-tada' : 'bx bx-bell'} />
					<span className="badge bg-danger rounded-pill">{unreadCount}</span>
				</DropdownToggle>

				<DropdownMenu className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0">
					<div className="p-3"></div>
				</DropdownMenu>
			</Dropdown>
		</React.Fragment>
	);
};

export default withTranslation()(BookingNotificationDropdown);

BookingNotificationDropdown.propTypes = {
	t: PropTypes.any
};
